import React, { useContext } from "react";
import themeContext from "../../../context/theme/ThemeContext";

const VerticalMore = () => {
  const { theme } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
    >
      <path
        d="M3.5 2C3.5 2.82386 2.82386 3.5 2 3.5C1.17614 3.5 0.5 2.82386 0.5 2C0.5 1.17614 1.17614 0.5 2 0.5C2.82386 0.5 3.5 1.17614 3.5 2ZM0.5 8C0.5 7.17614 1.17614 6.5 2 6.5C2.82386 6.5 3.5 7.17614 3.5 8C3.5 8.82386 2.82386 9.5 2 9.5C1.17614 9.5 0.5 8.82386 0.5 8ZM0.5 14C0.5 13.1761 1.17614 12.5 2 12.5C2.82386 12.5 3.5 13.1761 3.5 14C3.5 14.8239 2.82386 15.5 2 15.5C1.17614 15.5 0.5 14.8239 0.5 14Z"
        stroke={theme.palette.inactiveTool}
        fill={theme.palette.inactiveTool}
      />
    </svg>
  );
};

export default VerticalMore;
